export default {
      id: "briefcase-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#briefcase-usage",
      toString: function () {
        return this.url;
      }
    }